<template>
  <span @click="toggleEdit" class="editable-string" :class="{edit:edit}">
    <input v-if="on"
           v-model="textBuffer"
           ref="text-input"
           @blur="onBlur"
           @keyup.enter="finishEditing"
           @keyup.esc="escape"
           v-autowidth="{maxWidth: '100%', minWidth: '20px', comfortZone: 0}"
           v-focus
           :placeholder="placeholder">
  <span v-else>{{textBuffer}}</span>
  </span>
</template>

<script>
export default {
  name: 'editable-string',
  props: {
    value: String,
    defaultValue: String,
    edit: Boolean,
    placeholder: String
  },

  data () {
    return {
      textBuffer: '',
      editing: true
    }
  },

  computed: {
    on () {
      return this.edit && this.editing
    }
  },

  methods: {
    toggleEdit (e) {
      if (this.edit && !this.editing) {
        e.stopImmediatePropagation()
        this.editing = true
      }
    },

    onBlur () {
      this.editing = false
      this.$emit('input', this.textBuffer)
    },

    finishEditing () {
      this.$emit('input', this.textBuffer)
      this.$emit('escape')
      if (!this.textBuffer) this.textBuffer = this.defaultValue
    },

    escape () {
      this.textBuffer = this.value
      this.$emit('escape')
    }
  },

  mounted () {
    this.textBuffer = this.value
  },

  watch: {
    value (val) {
      this.textBuffer = val
    },

    edit (newValue, oldValue) {
      if (newValue) {
        this.textBuffer = this.value
      } else {
        if (oldValue) {
          this.finishEditing()
        }
      }
      this.editing = newValue
    }
  },

  directives: {
    focus: {
      inserted (el) {
        el.focus()
      }
    }
  }
}
</script>

<style lang="scss">
  $input-corner-radius: 0 !default;

  @import "../../../../scss/vars";
  @import "../../../../scss/mixins";

  .editable-string {
    $input-height: $two-thirds;
    display: flex;
    min-width: 0;
    align-items: center;

    input, span {
      display: block;
      box-sizing: content-box;
      margin: 0;
      height: $input-height !important;
      min-height: $input-height;
      padding: 0 $small-padding/2;
      background: transparent;
      border: none;
      border-radius: $input-corner-radius;
      box-shadow: none;

      line-height: calc(#{$input-height} + 1px) !important; // +1px fix of inconsistency between input & span text rendering
      font-size: inherit;
      font-family: inherit;
      font-weight: inherit;
      font-style: inherit;
      font-feature-settings: inherit;
      font-kerning: inherit;
      font-stretch: inherit;
      font-variant: inherit;
      font-variant-caps: inherit;
      font-variant-ligatures: inherit;
      font-variant-numeric: inherit;
      letter-spacing: inherit;
      text-transform: inherit;
    }

    &.edit {
      input, span {
        $normal-color: rgba(0, 0, 0, 0.04);
        background: $normal-color;
        box-shadow: -5px 0 0 0px $normal-color;
        border: none;
      }
    }

    input.edit:focus {
      $focus-color: rgba(0, 0, 0, 0.3);
      //background: $focus-color !important;
      box-shadow: 0 1px 0 0 $focus-color;
    }

    span {
      max-width: 100%;
      min-width: 0;
      padding-right: 9px; // TODO: it is just a quick patch.. has to fix difference in width between span and the input
      /*margin-right: 2px;*/
      @include text-ellipsis;
    }
  }
</style>
